export const setToken = (token) => {
  localStorage.setItem('token', token)
}
export const getToken = () => {
  const token = localStorage.getItem('token')
  if (token) {
    return token
  } else {
    return false
  }
}
export const parseParam = function(param) {
  var paramStr = "";
  console.log(param)
  paramStr= Object.keys(param).map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(param[key]); }).join("&");
  return paramStr.substr(1);

}
// 校验起始流水号 和结束流水号 
export const verifyBatch=(originalStart=0,originalEnd=0,newStart=0,newEnd=0)=>{
      if(newStart.length!=originalStart.length){
        return false
      }
      if(newEnd.length!=originalEnd.length){
        return false
      } 
      if(Number(newStart)<Number(originalStart)||Number(newStart)>Number(originalEnd)){
        return false
      }
      if(Number(newEnd)>Number(originalEnd)||Number(newEnd)<Number(originalEnd)){
        return false
      }
      if(Number(newStart)>Number(newEnd)){
        return false
      }
      return true
}
// 数字转布尔
export const number2Boolean = (number) => {
  return !!number;
};
// 布尔转数字
export const boolean2Number = (boo) => {
  return boo ? 1 : 0;
};

// 获取今天 YYYY
export const getToday = (boo) => {
      var time=new Date()
      let year = time.getFullYear();
      let month = time.getMonth() + 1 > 10 ? time.getMonth()+1 : '0'+(time.getMonth()+1);
      let day = time.getDate() > 10 ? time.getDate() : "0" + time.getDate();
      return year + "-" + month + "-" + day;
};



// 过滤数据 去掉省  自治区等。。
export const filterAreaSuffix = (data) => {
  var mapData=data
  for (var i in mapData) {
 
    if(mapData[i].name){
      if (mapData[i].name.indexOf('省') !== -1) {
        mapData[i].name = mapData[i].name.split("省").join("")
      }
      if (mapData[i].name.indexOf('自治区') !== -1) {
        mapData[i].name = mapData[i].name.split("自治区").join("")
        if (mapData[i].name.indexOf('回族') !== -1) {
          mapData[i].name = mapData[i].name.split("回族").join("")
        }
        if (mapData[i].name.indexOf('维吾尔') !== -1) {
          mapData[i].name = mapData[i].name.split("维吾尔").join("")
        }
        if (mapData[i].name.indexOf('壮族') !== -1) {
          mapData[i].name = mapData[i].name.split("壮族").join("")
        }
      }
      if (mapData[i].name.indexOf('特别行政区') !== -1) {
        mapData[i].name = mapData[i].name.split("特别行政区").join("")
      }
    }

  }
  console.log(mapData)
  return mapData
};